<template>
  <div class="auth-page">
    <v-card class="auth-card" outlined>
      <div class="auth-header">
        <div>
          <h1>Restablecer contrasena</h1>
          <p>Ingresa el token recibido y tu nueva clave.</p>
        </div>
        <v-btn text color="primary" :to="{ name: 'login' }">Volver al inicio de sesion</v-btn>
      </div>

      <v-form ref="form" v-model="valid" lazy-validation>
        <v-text-field
          v-model="token"
          label="Token"
          outlined
          dense
          :rules="requiredRules"
        />
        <v-text-field
          v-model="newPassword"
          label="Nueva contrasena"
          outlined
          dense
          :type="showPassword ? 'text' : 'password'"
          :append-icon="showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
          @click:append="showPassword = !showPassword"
          :rules="requiredRules"
        />
        <v-btn
          color="primary"
          block
          class="auth-btn"
          :loading="loading"
          :disabled="!valid || loading"
          @click="submit"
        >
          Restablecer
        </v-btn>
        <div v-if="success" class="success-text">Clave actualizada correctamente.</div>
        <div v-if="error" class="error-text">{{ error }}</div>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import { authService } from "../services/auth";

export default {
  name: "ResetPassword",
  data() {
    return {
      valid: false,
      token: "",
      newPassword: "",
      showPassword: false,
      loading: false,
      error: "",
      success: false,
      requiredRules: [(v) => Boolean(v) || "Campo requerido"],
    };
  },
  methods: {
    async submit() {
      const isValid = this.$refs.form.validate();
      if (!isValid) return;
      this.error = "";
      this.success = false;
      this.loading = true;
      try {
        await authService.resetPassword({ token: this.token, newPassword: this.newPassword });
        this.success = true;
        this.newPassword = "";
      } catch (err) {
        this.error = "No pudimos actualizar la clave. Verifica el token.";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.auth-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
}

.auth-card {
  width: 100%;
  max-width: 560px;
  border-radius: 20px;
  padding: 28px;
}

.auth-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 20px;
}

.auth-header h1 {
  margin: 0 0 6px;
  font-size: 24px;
  font-weight: 700;
}

.auth-header p {
  margin: 0;
  color: #64748b;
}

.auth-btn {
  margin-top: 12px;
  height: 48px;
  font-weight: 700;
  text-transform: none;
}

.success-text {
  margin-top: 12px;
  color: #16a34a;
}

.error-text {
  margin-top: 12px;
  color: #dc2626;
}
</style>
